<template>
	<!-- <f7-page class="no-swipeback" profile> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="page-content">

  		<page-nav-bar currentServiceName="MoneyRoad" :subNavTitle="profilesPage_ProfileInformation" :menuAccess="true"></page-nav-bar>

  		<div class="layoutTop"/>
       <div class="container-fluid">
         <div class="row">
           <div class="col-md-10 offset-md-1">
             <div class="panel21 panel-default">

               <div class="panel-heading">
                 <h4 class="content-block labelAccordionForm">
                   <i class="fa fa-address-card"></i>
                   {{ $t('profilesPage.profiles_title') }}
                 </h4>
               </div>

          <form>
              <div class="form-group row">
                <label class="col-4 col-sm-2 col-form-label">{{ $t('common.idtfr') }}</label>
                <div class="col-8 col-sm-10">
                  <input class="form-control" type="text" v-model="accountLogin" disabled>
                  </input>
                </div>
              </div>
              <div class="form-group row" v-if="accountType === '2'">
                <label class="col-4 col-sm-2 col-form-label">{{ $t('common.nme') }}</label>
                <div class="col-8 col-sm-10">
                  <input class="form-control" type="text" v-model="accountName" disabled>
                  </input>
                </div>
              </div>
              <div class="form-group row" v-if="accountType === '1'">
                <label class="col-4 col-sm-2 col-form-label">{{ $t('common.nme') }}</label>
                <div class="col-8 col-sm-10">
                  <input class="form-control" type="text" v-model="accountName" disabled>
                  </input>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-4 col-sm-2 col-form-label">{{ $t('common.eml') }}</label>
                <div class="col-8 col-sm-10">
                  <input class="form-control" type="text" v-model="accountEmailReference" disabled>
                  </input>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-4 col-sm-2 col-form-label">{{ $t('common.adrs') }}</label>
                <div class="col-8 col-sm-10">
                  <input class="form-control" type="text" v-model="accountAddress" disabled>
                  </input>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-4 col-sm-2 col-form-label">{{ $t('common.cty') }}</label>
                <div class="col-8 col-sm-10">
                  <input class="form-control" type="text" v-model="accountCity" disabled>
                  </input>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-4 col-sm-2 col-form-label">{{ $t('common.zp_code') }}</label>
                <div class="col-8 col-sm-10">
                  <input class="form-control" type="text" v-model="accountZipCode" disabled>
                  </input>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-4 col-sm-2 col-form-label">{{ $t('common.ctry') }}</label>
                <div class="col-8 col-sm-10">
                  <input class="form-control" type="text" v-model="accountCountry" disabled>
                  </input>
                </div>
              </div>
              <div class="form-group row" v-if="accountType === '1'">
                <label class="col-4 col-sm-2 col-form-label">{{ $t('common.lgl_frm') }}</label>
                <div class="col-8 col-sm-10">
                  <input class="form-control" type="text" v-model="accountLegalForm" disabled>
                  </input>
                </div>
              </div>
              <div class="form-group row" v-if="accountType === '1'">
                <label class="col-4 col-sm-2 col-form-label">{{ $t('common.shr_cptl') }}</label>
                <div class="col-8 col-sm-10">
                  <input class="form-control" type="text" v-model="accountAmountOfCapital" disabled>
                  </input>
                </div>
              </div>
              <div class="form-group row" v-if="accountType === '1'">
                <label class="col-4 col-sm-2 col-form-label">{{ $t('common.tva_nbr') }}</label>
                <div class="col-8 col-sm-10">
                  <input class="form-control" type="text" v-model="accountIdentifierTVA" disabled>
                  </input>
                </div>
              </div>
            </form>


            <!--  </div>
            </div>
          </div>
        </div>-->
          </div>
        </div>
      </div>
      <div class="row justify-content-start" v-bind:class="colorBottomButton">
        <div class="offset-md-5 col-md-3">
          <a href="/profile/edit/" style="color: #000;">
            <button round type="button"  class="button-action">
              <f7-icon f7="edit"></f7-icon>
              <span>{{ $t('profilesPage.edit_prfl') }}</span>
            </button>
          </a>
        </div>
        <div class="col-md-3">
          <a href="/profile/changePassword/" style="color: #000;">
            <button round  class="button-action" @click="">
                <f7-icon f7="gear"></f7-icon>
                <span v-if="displayChangerPassword">{{ $t('common.chg_pwd') }}</span>
                <span v-else>{{ $t('common.def_pwd') }}</span>
            </button>
          </a>
        </div>
      </div>
      <div class="row">
        <div class="toolbarPageBottomBlank"></div>
      </div>
    </div>
  </div>
</div>
	<!-- </f7-page> -->
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
// import {errorMessageAlert} from '@/helpers/alert'
// import qrcode from 'qrcode'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      accountType: '',
      accountName: '',
      accountLogin: '',
      accountAddress: '',
      accountCity: '',
      accountZipCode: '',
      accountCountry: '',
      accountEmailReference: '',
      accountLegalForm: '',
      accountAmountOfCapital: '',
      accountIdentifierTVA: '',
      displayChangerPassword: true
    }
  },
  created () {
    this.profilesPage_ProfileInformation = this.$i18n.t('leftPanelTitle.prof_info')
    this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage
    this.accountType = this.$engine.user.get().type
    this.accountName = this.$engine.user.get().name
    this.accountLogin = this.$engine.user.get().identifier
    this.accountAddress = this.$engine.user.get().address
    this.accountCity = this.$engine.user.get().city
    this.accountZipCode = this.$engine.user.get().zip_code
    this.accountCountry = this.$engine.user.get().country
    this.accountEmailReference = this.$engine.user.get().email_reference
    this.accountLegalForm = this.$engine.user.get().legalForm
    this.accountAmountOfCapital = this.$engine.user.get().amountOfCapital
    this.accountIdentifierTVA = this.$engine.user.get().identifierTVA
  },
  mounted () {
    // var canvas = document.getElementById('qrcodeCanvas')
    //
    // let parameters = {
    //   idAccount: 92
    // }
    // console.log(JSON.stringify(parameters))
    // qrcode.toCanvas(canvas, JSON.stringify(parameters), function (error) {
    //   if (error) console.error(error)
    //   console.log('success!')
    // })
    if (this.$engine.user.connectBy === 'vue-google-oauth2') {
      this.displayChangerPassword = false
    } else {
      this.displayChangerPassword = true
    }
  }
}
</script>

<style scoped>
.container {
    width: 100%;
    height: auto;
}
.panel2, .panel21 {
    background: #fcfcfc;
    border: solid 1px #dbdbdb;
    /*margin-bottom: 5%;*/
    padding-bottom: 25px;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    float: left;
    width: 100%;
}
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

.orangeConfirmationButton {
  margin-top: 5%;
}
@media (max-width:  768px) {
  .col-md-3 {
    margin-top: -20px;
  }
}
</style>



// WEBPACK FOOTER //
// CMProfile.vue?e51ee976